import React from 'react';

import getConfig from 'next/config';

import { replaceDomain } from '@zego/utils';

import FluidBackgroundImageBase from './FluidBackgroundImageBase';

const {
  publicRuntimeConfig: { DEPLOY_ENV },
} = getConfig();

const IMGIX_DOMAIN =
  DEPLOY_ENV === 'development'
    ? 'https://zego-uploads-dev.imgix.net'
    : DEPLOY_ENV === 'qa'
    ? 'https://zego-uploads-qa.imgix.net'
    : DEPLOY_ENV === 'staging'
    ? 'https://zego-uploads-staging.imgix.net'
    : DEPLOY_ENV === 'integrations'
    ? 'https://zego-uploads-integrations.imgix.net'
    : 'https://zego-uploads.imgix.net';

export default function UploadedBackgroundImage({ src, ...props }) {
  return (
    <FluidBackgroundImageBase
      src={replaceDomain(src, IMGIX_DOMAIN)}
      {...props}
    />
  );
}
